import React from 'react';
import styled from 'styled-components';
import Button from 'components/button';
import Fees from './fees';
import { navigateToLeaseApplication } from '../../utils/navigate';
import EmbedViewer from 'components/embed-viewer';

const Wrapper = styled.div`
  background-color: #fff;
  border-radius: 6px;
  padding: 15px;
  border: 1px solid #e1e5eb;
  margin-bottom: 10px;
`;

const Row = styled.div`
  margin: 20px 0px;
  &:first-child {
    margin-top: 10px;
  }
  &:last-child {
    margin-bottom: 0px;
  }
`;

const CTA = styled(Button)`
  width: 100%;
  border-radius: 4px !important;
  margin-bottom: 7px;
  height: 40px;
`;

const Price = styled.div`
  font-size: 34px;
  font-weight: bold;
  padding: 20px 0px;
  border-top: 1px solid #e1e5eb;
  span {
    color: #888;
    font-size: 14px;
    font-weight: normal;
  }
`;

export const FeesAndPrice = ({ location, hideFees }) => {
  const { displayInfo } = location || {};
  return (
    <div>
      {!!displayInfo.formattedPrice && (
        <Row>
          <Price className="propertyPrice">
            {displayInfo.formattedPrice}
            <span>/month plus fees</span>
          </Price>
        </Row>
      )}
      {!hideFees && <Fees location={location} />}
    </div>
  );
};

export default ({ location, hideFees, floorplan }) => {
  const [showVirtualTour, setShowVirtualTour] = React.useState(false);

  const {
    handleWaitList,
    handleApply,
    handleShowing,
    applyEnabled,
    showingEnabled,
    waitListEnabled
  } = React.useMemo(() => {
    const representativeItem = floorplan || location;

    const handleApply = () => {
      navigateToLeaseApplication({ location: representativeItem });
    };
    const handleShowing = () => {
      if (['custom', 'rently', 'showmojo'].includes(representativeItem.aptlyShowings?.type)) {
        // This goes to app create, it will bounce and redirect as needed
        window.open(representativeItem.aptlyShowings.link, '_blank');
      } else {
        // This goes to app create, it will bounce and redirect as needed
        window.open(
          `/${location.companyInfo.id}/showing/app/showing/create/?cId=${representativeItem._id}`,
          '_blank'
        );
      }
    };
    const handleWaitList = () => {
      window.open(representativeItem?.waitList?.link, '_blank');
    };
    const contactUsEnabled = !!representativeItem?.aptlyListings?.contactFormUrl;
    const showingEnabled = !!representativeItem?.aptlyShowings?.active;
    const applyEnabled = !!representativeItem?.aptlyScreening?.active;
    const waitListEnabled =
      !!representativeItem?.waitList?.link &&
      !!representativeItem?.waitList?.enabled &&
      !applyEnabled;

    return {
      handleWaitList,
      handleApply,
      handleShowing,
      waitListEnabled,
      applyEnabled,
      contactUsEnabled,
      showingEnabled
    };
  }, [location, floorplan]);

  return (
    <Wrapper>
      <Row>
        {location.virtualTourUrl && (
          <CTA variant="secondary" onClick={() => setShowVirtualTour(true)}>
            Virtual Tour
          </CTA>
        )}
        {showingEnabled && (
          <CTA variant="primary" onClick={handleShowing}>
            Tour This Home
          </CTA>
        )}
        {applyEnabled && (
          <CTA variant="secondary" onClick={handleApply}>
            APPLY
          </CTA>
        )}
        {waitListEnabled && (
          <CTA variant="secondary" onClick={handleWaitList}>
            Join Waitlist
          </CTA>
        )}
      </Row>
      <FeesAndPrice location={location} hideFees={hideFees} />
      <EmbedViewer
        open={showVirtualTour}
        url={location.virtualTourUrl}
        onClose={() => setShowVirtualTour(false)}
      />
    </Wrapper>
  );
};
